import React, {useEffect}  from 'react';
import { Link } from 'gatsby';
import Head from '../components/Head';
import Layout from "../components/Layout";
import Sharebuttons from '../components/Sharebuttons';
import Chartholder from '../components/Chartholder';

const Post = ({ pageContext: { pgCtxt } }) => {

  let prevPost, nextPost;
  const postId = pgCtxt.post.elementID;
  const postIndex = pgCtxt.allPosts.findIndex(item=>item.elementID===postId);
  const dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  const postDate = new Date(pgCtxt.post.elementDetails.createDate);
  const formattedDate = postDate.toLocaleDateString("en-US", dateOptions);

  // next and previous blog posts
  if (pgCtxt.allPosts.length > 1) {
      if (postIndex > 0) {
          nextPost = <Link className="btn btn-labeled btn-link text-end small"
          to={`/posts/${pgCtxt.allPosts[postIndex - 1].elementID}`}
          title={pgCtxt.allPosts[postIndex - 1].elementDetails.title}>
          {pgCtxt.allPosts[postIndex - 1].elementDetails.title}
          <span class="btn-label"><i className="bi bi-chevron-right"></i></span>
          </Link>;
        } else {
          nextPost = <></>;
      }
      if (postIndex < pgCtxt.allPosts.length - 1) {
          prevPost = <Link className="btn btn-labeled btn-link text-start small"
          to={`/posts/${pgCtxt.allPosts[postIndex + 1].elementID}`}
          title={pgCtxt.allPosts[postIndex + 1].elementDetails.title}>
          <span className="btn-label"><i className="bi bi-chevron-left"></i></span>
          {pgCtxt.allPosts[postIndex + 1].elementDetails.title}
          </Link>;
        } else {
          prevPost = <></>;
      }
  }


  return (
    <Layout>
      <section>
          <div className="container">
              
            <Head pageTitle={pgCtxt.post.elementDetails.title} title={pgCtxt.post.elementDetails.title} path={'/posts/' + pgCtxt.post.elementID} description={pgCtxt.post.briefDescription} imageUrl={pgCtxt.post.elementDetails.imageUrl} type="website" datePublished={pgCtxt.post.elementDetails.createDate} />

              {(() => {
                  switch (pgCtxt.post.elementDetails.chartOrImage) {
                      case "chart":
                          return <><Chartholder chartData={pgCtxt.post.elementDetails.chartData}></Chartholder></>
                          break;
                      case "image":
                          return <div className="blog-page-image mt-lg-4 ratio ratio-21x9" style={{backgroundImage: `url(${pgCtxt.post.elementDetails.imageUrl})`, backgroundRepeat: "no-repeat", backgroundPosition: "center", backgroundSize: "cover"}}>&nbsp;</div>
                          break;
                      default:
                          return <></>
                  }
              })()}

              <div class="section-title mt-5">
                <h2>by {pgCtxt.post.elementDetails.author}</h2>
                <h3>{pgCtxt.post.elementDetails.title}</h3>
                <p className="small text-muted">{formattedDate}</p>
              </div>

              { <div dangerouslySetInnerHTML={{ __html: pgCtxt.post.elementDetails.content }} /> }

              <div class="row">
                  <div className="col-12 my-3 text-center">
                      <Sharebuttons title={pgCtxt.post.elementDetails.title} path={'/posts/' + pgCtxt.post.elementID} twitterHandle={'@Level1Analytics'} tags={pgCtxt.post.elementDetails.keywords} image={pgCtxt.post.elementDetails.imageUrl} />
                  </div>
              </div>

              <div className="row border-top border-bottom">
                  <div className="col-md-6 small text-start p-3">{prevPost}</div>
                  <div className="col-md-6 small text-end p-3">{nextPost}</div>
              </div>
              
          </div>
      </section>
    </Layout>
  );
}
export default Post;